
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Smartphone, ArrowLeft } from 'lucide-react';
import ShareButton from '@/components/ShareButton';

interface PlatformHeaderProps {
  platform: string;
}

const PlatformHeader: React.FC<PlatformHeaderProps> = ({ platform }) => {
  const location = useLocation();
  // Use the full absolute URL for sharing
  const currentUrl = `${window.location.origin}${location.pathname}`;
  const shareTitle = `${platform} Apps and Tools - FitnessAppSearch`;

  return (
    <div className="mb-8">
      <Link to="/platforms" className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-4">
        <ArrowLeft className="h-4 w-4 mr-1" />
        Back to Platforms
      </Link>
      
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-3">
          <Smartphone className="h-6 w-6 text-gray-600" />
          <h1 className="text-3xl font-bold">{platform} Apps</h1>
        </div>
        <ShareButton 
          title={shareTitle}
          url={currentUrl}
        />
      </div>
      
      <p className="text-gray-600">
        Discover the best fitness apps available for {platform.toLowerCase()}.
      </p>
    </div>
  );
};

export default PlatformHeader;
